export default "__VITE_ASSET__C4cpjFnl__"